export * from './activeVariantsMap'
export * from './viewerManagerStructureApi'
export * from './viewerManagerDataApi'
export * from './beckyPropsInitialStore'
export * from './builderPropsRuntimeOverridesStore'
export * from './platform'
export * from './layoutDone'
export * from './languageChangeHandler'
export * from './appSpecUpdatedHandler'
export * from './manifest'
export * from './componentWindowResolver'
export * from './editorVsmExperiments'

export const RuntimeApiSymbol = Symbol('RuntimeApi')
export const ViewerManagerRuntimeApiSymbol = Symbol('ViewerManagerRuntimeApi')
export interface IViewerManagerRuntimeActiveVariantsApi {
	runtime: {
		setActiveVariants: (pathOrCompId: string | string[], variantIds: string[]) => void
		getActiveVariants: (pathOrCompId: string | string[]) => string[]
		resetActiveVariants: (pathOrCompId?: string | string[], variantIds?: string[]) => void
		clearActiveVariants: () => void
	}
}
export const CarmiInstance = Symbol('CarmiInstance')
/**
 * The engine-independent grouped write contract for the editor model, typed by
 * `EditorModelSetters` from `@wix/thunderbolt-editor-model-setters`. Features should depend on this
 * instead of `CarmiInstance`, which stays for engine setup, debugging and adapter tests.
 */
export const EditorModelSettersSymbol = Symbol('EditorModelSetters')
/**
 * The engine-independent batching dependency for the editor model, typed by `EditorModelBatching`
 * from `@wix/thunderbolt-editor-model-setters`. Deliberately separate from
 * `EditorModelSettersSymbol`: grouping writes into a batch and performing them are different
 * concerns, and most consumers need only one of the two.
 */
export const EditorModelBatchingSymbol = Symbol('EditorModelBatching')
export const isViewerFragmentSymbol = Symbol('isViewerFragment')
export const DataRequirementsCheckerSymbol = Symbol('DataRequirementsChecker')
export const PagesModelsRegistrarSymbol = Symbol('PagesModelsRegistrar')
export const TBInstanceIdSymbol = Symbol('tbInstanceId')
export const EditorVsmApiSymbol = Symbol('EditorVsmApi')
export const VsmPageConfigsFactoriesSymbol = Symbol('VsmPageConfigsFactories')
export const MarkBuilderComponentsAsDeadHandlerSymbol = Symbol('MarkBuilderComponentsAsDeadHandler')
export const VsmMasterPageConfigsFactoriesSymbol = Symbol('VsmMasterPageConfigsFactories')
// Editor VSM aggregation maps (explicit per-feature editor entries; bound under the `vsm_editor` gate).
export const EditorSiteConfigsFactoriesSymbol = Symbol('EditorSiteConfigsFactories')
export const EditorOnlyConfigsFactoriesSymbol = Symbol('EditorOnlyConfigsFactories')
export const EditorSideEffectsFactoriesSymbol = Symbol('EditorSideEffectsFactories')

/**
 * The site feature configs of every editor feature, keyed by feature name — the union of the Carmi
 * aggregation and the editor VSM `createSiteConfigs` map, assembled once in `initThunderboltDs` from the
 * same two inputs that feed the per-feature `SiteFeatureConfigSymbol` bindings (so it cannot drift from
 * them). Consumers that need the whole map — the platform worker bootstrap forwards every `*WixCodeSdk`
 * entry to the SDK factories — must read it from here and never from Carmi's `siteFeaturesConfigs`
 * aggregate: that one drops features as they migrate to VSM (ADR-0007).
 */
export const SiteFeaturesConfigsSymbol = Symbol('SiteFeaturesConfigs')
